import React, { useState, useEffect } from "react";
import "./IndicationHistoryPanel.css";
import { Button, CircularProgress } from "@mui/material";
import CloseIcon from "../../../components/CloseIcon";
import { useNitroStore } from "../../../store/Store";
import CompetitorIndication from "../../../panels/competitiveAnalysisModal/components/Competitor/components/CompetitorIndication";

const IndicationHistoryPanel: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    showIndicationHistoryPanel,
    setShowIndicationHistoryPanel,
    indicationHistory,
    setShowAddIndicationHistoryPanel,
  } = useNitroStore((state) => ({
    showIndicationHistoryPanel: state.showIndicationHistoryPanel,
    setShowIndicationHistoryPanel: state.setShowIndicationHistoryPanel,
    indicationHistory: state.indicationHistory,
    setShowAddIndicationHistoryPanel: state.setShowAddIndicationHistoryPanel,
  }));

  useEffect(() => {
    if (showIndicationHistoryPanel) {
      setIsLoading(true);

      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [showIndicationHistoryPanel]);

  useEffect(() => {
    if (
      showIndicationHistoryPanel &&
      indicationHistory &&
      indicationHistory.length > 0
    ) {
      setIsLoading(false);
    }
  }, [indicationHistory, showIndicationHistoryPanel]);

  useEffect(() => {
    if (!showIndicationHistoryPanel) {
      setIsLoading(false);
    }
  }, [showIndicationHistoryPanel]);

  const sortedIndications = [...(indicationHistory || [])].sort(
    (a, b) =>
      new Date(b.dateLogged).getTime() - new Date(a.dateLogged).getTime(),
  );

  const [latestIndication, ...historyIndications] = sortedIndications;

  if (!showIndicationHistoryPanel) {
    return null;
  }

  return (
    <div className="indication-history-modal">
      <div className="panel-container">
        <div className="indication-history-header">
          <div
            style={{
              margin: "0px 32px",
              fontWeight: 500,
              fontSize: 26,
              width: "100%",
              textAlign: "center",
            }}
          >
            <div className="origin-name">
              {latestIndication?.originName || "Indication History"}
            </div>
          </div>
          <div style={{ position: "absolute", right: 8, top: 8 }}>
            <CloseIcon
              onClick={() => {
                setShowIndicationHistoryPanel(false);
              }}
            />
          </div>
        </div>

        <div className="panel-body">
          {isLoading && (
            <div className="loading-container">
              <CircularProgress size="32px" />
              <span style={{ fontSize: "16px", color: "#5f6368" }}>
                Loading indication history...
              </span>
            </div>
          )}

          {!isLoading && sortedIndications.length === 0 && (
            <div>
              <div className="empty-history-container">
                <p>No indication history</p>
              </div>
              <div className="add-indication-container-empty">
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowAddIndicationHistoryPanel(true);
                    setShowIndicationHistoryPanel(false);
                  }}
                >
                  + Add Indication
                </Button>
              </div>
            </div>
          )}

          {!isLoading && sortedIndications.length > 0 && (
            <>
              {latestIndication && (
                <div style={{ margin: "0 16px 20px" }}>
                  <CompetitorIndication indication={latestIndication} />
                </div>
              )}

              <div className="add-indication-container">
                <Button
                  variant="contained"
                  onClick={() => {
                    setShowAddIndicationHistoryPanel(true);
                    setShowIndicationHistoryPanel(false);
                  }}
                >
                  + Add Indication
                </Button>
              </div>

              {historyIndications.length > 0 && (
                <div className="history-list-container">
                  <div className="history-heading">Indication History</div>
                  {historyIndications.map((i) => (
                    <CompetitorIndication indication={i} minimize />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default IndicationHistoryPanel;
